<form class="flex flex-col w-full" [formGroup]="dossierInterventionForm" (ngSubmit)="onFormSubmit()">
    <div class="flex flex-col sm:flex-row p-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Numéro de dossier</mat-label>
            <input type="text" matInput formControlName="no_dossier">
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Compagnie d'assurance</mat-label>
            <input type="text" matInput formControlName="compagnie_assurance">
        </mat-form-field>
    </div>
    <div class="flex flex-col sm:flex-row p-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Nom de l'assuré</mat-label>
            <input type="text" matInput formControlName="nom_assure">
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Date de la perte</mat-label>
            <input type="date" matInput formControlName="date_perte">
        </mat-form-field>
    </div>
    <div class="flex flex-col sm:flex-row p-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Adresse de la propriété endommagée</mat-label>
            <input type="text" matInput formControlName="adresse_propriete_endommagee">
        </mat-form-field>
        <mat-form-field class="w-full">
            <mat-label>Personne contact</mat-label>
            <input type="text" matInput formControlName="personne_contact">
        </mat-form-field>
    </div>
    <div class="flex flex-col sm:flex-row p-8 pb-0 space-x-4">
        <mat-form-field class="w-full">
            <mat-label>Commentaires</mat-label>
            <input type="text" matInput formControlName="commentaires">
        </mat-form-field>
    </div>

    <div class="flex items-center justify-between w-full border-t px-8 py-4">
        <button *ngIf="currentDossierIntervention.id !== 0 && isAdmin" type="button" (click)="delete(currentDossierIntervention.id)" class="-ml-4" mat-button [color]="'warn'">
            Supprimer
        </button>
        <div class="flex items-center">
            <div class="flex items-center mr-4">
                <ng-container *ngIf="success">
                    <mat-icon class="text-green-500" [svgIcon]="'heroicons_outline:check'"></mat-icon>
                    <span class="ml-2">Le dossier d'intervention a été mis à jour</span>
                </ng-container>
                <ng-container *ngIf="error">
                    <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    <span class="ml-2">Erreur lors de l'enregistrement, réessayez!</span>
                </ng-container>
                <ng-container *ngIf="noDossierDejaUtiliser">
                    <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    <span class="ml-2">Le numéro de dossier est déjà utilisé</span>
                </ng-container>
            </div>
            <button type="submit" mat-flat-button [color]="'primary'">
                Enregistrer
            </button>
        </div>
    </div>
</form>
